import React from 'react'
import DashboardLayout from 'layout/DashboardLayout'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import CompanyDetails from './components/CompanyDetails'
import ResetPassword from './components/ResetPassword'

const Settings = () => {
    let { section }: any = useParams()

    return (
        <DashboardLayout>
            <div className='grid grid-cols-9 xl:grid-cols-6 h-full'>
                <div className='col-span-3 lg:col-span-2 xl:col-span-1 border border-snow-100 bg-white h-full pt-10 hidden md:block'>
                    <div className='xl:w-10/12 pl-1 grid gap-8 fixed transform -translate-x-full md:translate-x-0'>
                        <Link to='/settings/details' className='flex items-center pl-12'>
                            <svg
                                width='24'
                                height='24'
                                viewBox='0 0 24 24'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d='M12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7C16 9.20914 14.2091 11 12 11Z'
                                    fill={section === 'details' ? '#52BD95' : '#B3B3B3'}
                                    opacity={section === 'details' ? '1' : '0.3'}
                                />
                                <path
                                    d='M3.00065 20.1992C3.38826 15.4265 7.26191 13 11.9833 13C16.7712 13 20.7049 15.2932 20.9979 20.2C21.0096 20.3955 20.9979 21 20.2467 21C16.5411 21 11.0347 21 3.7275 21C3.47671 21 2.97954 20.4592 3.00065 20.1992Z'
                                    fill={section === 'details' ? '#0D1537' : '#B3B3B3'}
                                />
                            </svg>

                            <span
                                className={`${
                                    section !== 'details' ? 'opacity-50' : 'font-medium'
                                } text-dark text-sm ml-2`}
                            >
                                Company details
                            </span>
                        </Link>
                        <Link to='/settings/security' className='flex items-center pl-12'>
                            <svg
                                width='24'
                                height='24'
                                viewBox='0 0 24 24'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    fillRule='evenodd'
                                    clipRule='evenodd'
                                    d='M4 4.00006L11.6314 2.56917C11.875 2.52349 12.125 2.52349 12.3686 2.56917L20 4.00006V13.2831C20 16.2174 18.4883 18.9448 16 20.5001L12.53 22.6688C12.2057 22.8715 11.7943 22.8715 11.47 22.6688L8 20.5001C5.51165 18.9448 4 16.2174 4 13.2831V4.00006Z'
                                    fill={section === 'security' ? '#0D1537' : '#B3B3B3'}
                                    opacity={section === 'security' ? '1' : '0.3'}
                                />
                                <path
                                    fillRule='evenodd'
                                    clipRule='evenodd'
                                    d='M14.5 11C15.0523 11 15.5 11.4477 15.5 12V15C15.5 15.5523 15.0523 16 14.5 16H9.5C8.94772 16 8.5 15.5523 8.5 15V12C8.5 11.4477 8.94772 11 9.5 11V10.5C9.5 9.11929 10.6193 8 12 8C13.3807 8 14.5 9.11929 14.5 10.5V11ZM12 9C11.1716 9 10.5 9.67157 10.5 10.5V11H13.5V10.5C13.5 9.67157 12.8284 9 12 9Z'
                                    fill={section === 'security' ? '#52BD95' : '#B3B3B3'}
                                />
                            </svg>

                            <span
                                className={`${
                                    section !== 'security' ? 'opacity-50' : 'font-medium'
                                } text-dark text-sm ml-2`}
                            >
                                Reset password
                            </span>
                        </Link>
                    </div>
                </div>
                <div className='col-span-9 md:col-span-6 lg:col-span-7 xl:col-span-5 px-12 py-10'>
                    {section === 'details' && <CompanyDetails />}
                    {section === 'security' && <ResetPassword />}
                    <div className="h-24 "></div>
                </div>
            </div>
        </DashboardLayout>
    )
}

export default Settings
